import { useAddonPrice, useFormatters, type AddonPrice } from "../features/workspace/shared";
import { usePermissions } from "../session/permissions";

interface SeatPrice {
  /** One seat for one `per` (a year of an annual subscription is 10 months, DEC-135). */
  unit: number;
  /** One seat if bought now: `unit`, prorated to the days left in a paid year. */
  dueNow: number;
  per: "month" | "year";
  proration: AddonPrice["proration"];
  currency: string;
  format: (amount: number) => string;
}

/** Extra-seat add-on price in the workspace currency (`null` until known / without billing.view). */
export function useSeatPrice(): SeatPrice | null {
  const fmt = useFormatters();
  const permissions = usePermissions();
  const seat = useAddonPrice("extra_seat", permissions.can("billing.view"));
  if (!seat) return null;
  return {
    unit: Number(seat.intervalPrice),
    dueNow: Number(seat.dueNow),
    per: seat.per ?? "month",
    proration: seat.proration,
    currency: seat.currency,
    format: (amount) => fmt.money(amount, seat.currency),
  };
}
